import type { StateTree, EmployeeDetailsState, EmployeeDetails } from '@makemydeal/dr-dash-types';
import { EmployeeRole } from '@makemydeal/dr-platform-types';

export const getState = (state: any): EmployeeDetailsState => state.employeeDetails;

export const getSlideOutOpen = (state: StateTree) => getState(state).slideOutOpen;

export const getSendingUpdate = (state: StateTree) => getState(state).sendingUpdate;

export const getSendUpdateSuccess = (state: StateTree) => getState(state).sendUpdateSuccess;

export const getEmployeeDetails = (state: StateTree) => getState(state).employees;

export const getSalesManager = (state: StateTree): EmployeeDetails | undefined =>
    getState(state)?.employees?.[EmployeeRole.SalesManager];

export const getPrimarySalesperson = (state: StateTree) => getEmployeeDetails(state)?.PrimarySalesperson;

export const getPrimarySalespersonFirstName = (state: StateTree) => getPrimarySalesperson(state)?.name?.firstName;

export const getPrimarySalespersonLastName = (state: StateTree) => getPrimarySalesperson(state)?.name?.lastName;

export const getSearchResults = (state: StateTree) => getState(state).searchResults;

export const getSearchLoading = (state: StateTree) => getState(state).searchLoading;

export const getSearchError = (state: StateTree) => getState(state).searchError;
